export default "__VITE_ASSET__C$cDhMkg__"